import "./ReviewEventFlow.css";

const REVIEW_EVENT_ASSETS = {
  hero: "/static/img/schedule/review-event-7159-11081-hero.png",
  megaphone: "/static/img/home/home-upcoming-prep-megaphone.png",
  back: "/static/img/schedule/schedule-back-chevron.svg",
  calendar: "/static/img/schedule/schedule-6998-calendar.svg",
  time: "/static/img/schedule/schedule-6998-time.svg",
  location: "/static/img/schedule/schedule-6998-location.svg",
  camera: "/static/img/schedule/schedule-6998-camera.svg",
};

const DEFAULT_EVENT = {
  title: "후기 이벤트",
  description: "후기 이벤트를 통해 보정본 3컷을 추가로 받아보세요!",
  expectedAssetCount: 3,
  consent: { required: false },
};

function ReviewEventStatusBar({ nodeId }) {
  return (
    <div className="review-event-flow__status" data-node-id={nodeId} aria-hidden="true">
      <span>10:20</span>
      <span className="review-event-flow__status-icons">
        <i />
        <i />
        <i />
      </span>
    </div>
  );
}

function ReviewEventHeader({ onBack, screen = "apply", backDisabled = false }) {
  const isComplete = screen === "complete";

  return (
    <header className="review-event-flow__header" data-node-id={isComplete ? "7159:11207" : "7159:11130"}>
      <button
        type="button"
        aria-label="촬영일정으로 돌아가기"
        disabled={backDisabled}
        onClick={onBack}
        data-node-id={isComplete ? "7159:11208" : "7159:11131"}
      >
        <img src={REVIEW_EVENT_ASSETS.back} alt="" aria-hidden="true" />
      </button>
      <h1 data-node-id={isComplete ? "7159:11211" : "7159:11134"}>후기 이벤트 신청</h1>
      <span aria-hidden="true" />
    </header>
  );
}

function ReviewEventFooter({
  onClick,
  label,
  pending = false,
  disabled = false,
  screen = "apply",
}) {
  const isComplete = screen === "complete";

  return (
    <footer className="review-event-flow__footer" data-node-id={isComplete ? "7159:11186" : "7159:11082"}>
      <button
        type="button"
        onClick={onClick}
        disabled={pending || disabled}
        data-node-id={isComplete ? "7159:11188" : "7159:11084"}
      >
        <span data-node-id={isComplete ? "7159:11190" : "7159:11086"}>
          {pending ? "신청 중..." : label}
        </span>
      </button>
    </footer>
  );
}

export function ReviewEventApplyPage({
  onBack,
  onApply,
  pending = false,
  errorMessage = "",
  event,
  acceptedTerms = false,
  onAcceptedTermsChange = () => {},
  available = true,
  unavailableMessage = "",
}) {
  const reviewEvent = event || DEFAULT_EVENT;
  const termsRequired = Boolean(reviewEvent.consent?.required);
  const applyDisabled = !available || (termsRequired && !acceptedTerms);
  const expectedAssetCount = Number(reviewEvent.expectedAssetCount) || 3;

  return (
    <section className="review-event-flow-page mobile-app-frame" data-node-id="7159:11081">
      <ReviewEventStatusBar nodeId="7159:11129" />
      <ReviewEventHeader onBack={onBack} backDisabled={pending} />

      <main className="review-event-flow__main review-event-flow__main--apply" data-node-id="7159:11184">
        <section className="review-event-flow__hero" data-node-id="7159:11158">
          <span className="review-event-flow__hero-image" data-node-id="7159:11091" aria-hidden="true">
            <img src={REVIEW_EVENT_ASSETS.hero} alt="" />
          </span>
          <div className="review-event-flow__hero-title" data-node-id="7159:11156">
            <h2 data-node-id="7159:11155">
              {reviewEvent.description || `${reviewEvent.title}에 신청하고 보정본 ${expectedAssetCount}컷을 받아보세요!`}
            </h2>
          </div>
        </section>

        <section className="review-event-flow__notice" data-node-id="7159:11159">
          <div data-node-id="7159:11162">
            <h3 data-node-id="7159:11163">{reviewEvent.title || "안내사항"}</h3>
            <ul data-node-id="7159:11164">
              <li>후기 작성은 필요하지 않습니다.</li>
              <li>신청이 승인되면 스튜디오에서 보정본 {expectedAssetCount}컷을 준비합니다.</li>
              <li>사진이 업로드되면 알림과 마이페이지에서 확인할 수 있습니다.</li>
            </ul>
          </div>
        </section>

        {reviewEvent.terms ? (
          <section className="review-event-flow__terms" aria-label="후기 이벤트 약관">
            <h3>{reviewEvent.terms.title || "후기 이벤트 이용약관"}</h3>
            <p>{reviewEvent.terms.content}</p>
            {reviewEvent.terms.version ? <small>약관 버전 {reviewEvent.terms.version}</small> : null}
          </section>
        ) : null}

        {termsRequired ? (
          <label className="review-event-flow__consent">
            <input
              type="checkbox"
              checked={acceptedTerms}
              disabled={pending || !available}
              onChange={(eventObject) => onAcceptedTermsChange(eventObject.target.checked)}
            />
            <span>{reviewEvent.consent?.text || "후기 이벤트 이용약관에 동의합니다. (필수)"}</span>
          </label>
        ) : null}

        {!available && unavailableMessage ? (
          <p className="review-event-flow__error" role="alert">{unavailableMessage}</p>
        ) : null}
        {errorMessage ? <p className="review-event-flow__error" role="alert">{errorMessage}</p> : null}
      </main>

      <ReviewEventFooter
        onClick={onApply}
        label="이벤트 신청하기"
        pending={pending}
        disabled={applyDisabled}
      />
    </section>
  );
}

function ScheduleInfoRow({ icon, children, nodeId }) {
  return (
    <div className="review-event-flow__info-row" data-node-id={nodeId}>
      <img src={REVIEW_EVENT_ASSETS[icon]} alt="" aria-hidden="true" />
      <span>{children}</span>
    </div>
  );
}

export function ReviewEventCompletePage({ schedule, event, onBack, onConfirm }) {
  const safeSchedule = schedule || {};
  const expectedAssetCount = Number(event?.expectedAssetCount) || 3;

  return (
    <section className="review-event-flow-page mobile-app-frame" data-node-id="7159:11185">
      <ReviewEventStatusBar nodeId="7159:11206" />
      <ReviewEventHeader onBack={onBack} screen="complete" />

      <main className="review-event-flow__main review-event-flow__main--complete" data-node-id="7159:11254">
        <section className="review-event-flow__complete-copy" data-node-id="7159:11212">
          <div className="review-event-flow__complete-title" data-node-id="7159:11213">
            <span className="review-event-flow__check" data-node-id="7159:11214" aria-hidden="true"><i /></span>
            <h2 data-node-id="7159:11215">후기 이벤트 신청 완료!</h2>
          </div>
          <p data-node-id="7159:11216">보정본 {expectedAssetCount}컷이 준비되면 알림으로 안내드릴게요.</p>
        </section>

        <div className="review-event-flow__complete-panels" data-node-id="7159:11267">
          <section className="review-event-flow__push-card" data-node-id="7159:11255">
            <span className="review-event-flow__megaphone" data-node-id="7159:11264" aria-hidden="true">
              <img src={REVIEW_EVENT_ASSETS.megaphone} alt="" />
            </span>
            <p data-node-id="7159:11260">
              알림은 앱 푸시로 발송되며<br />
              <strong>마이페이지 사진 보관함</strong>에서도 확인할 수 있습니다.
            </p>
          </section>

          <section className="review-event-flow__info-card" data-node-id="7159:11196">
            <h3 data-node-id="7159:11253">신청 정보</h3>
            <div className="review-event-flow__info" data-node-id="7159:11220">
              <p className="review-event-flow__package" data-node-id="7159:11222">{safeSchedule.packageName || "촬영 패키지"}</p>
              <h2 data-node-id="7159:11225">{safeSchedule.title || "촬영"}</h2>
              <div className="review-event-flow__info-rows" data-node-id="7159:11226">
                <ScheduleInfoRow icon="calendar" nodeId="7159:11227">{safeSchedule.date || "일정 확인 필요"}</ScheduleInfoRow>
                <ScheduleInfoRow icon="time" nodeId="7159:11230">{safeSchedule.time || "시간 확인 필요"}</ScheduleInfoRow>
                <ScheduleInfoRow icon="location" nodeId="7159:11233">{safeSchedule.studio || "스튜디오 확인 필요"}</ScheduleInfoRow>
                <ScheduleInfoRow icon="camera" nodeId="7159:11236">{safeSchedule.type || "촬영"}</ScheduleInfoRow>
              </div>
            </div>
          </section>
        </div>
      </main>

      <ReviewEventFooter onClick={onConfirm} label="확인" screen="complete" />
    </section>
  );
}
